/**
 * App shell — masthead (wordmark + role-aware nav) + content area. The wordmark
 * is the one all-caps exception.
 */
import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GlobalNav } from './GlobalNav';

// Routes that never show the global nav: the public contractor bid page (no
// login) and the sign-in flow. The nav also self-hides when signed out, but we
// keep /bid explicit so a logged-in staffer following a bid link still sees a
// clean public page.
function hideNav(pathname: string): boolean {
  return pathname.startsWith('/bid/') || pathname === '/' || pathname === '/verify';
}

export function Shell({ children }: { children: ReactNode }): JSX.Element {
  const { pathname } = useLocation();
  return (
    <div className="app-shell">
      <header className="app-mast">
        <div className="app-mast__wrap">
          <Link to="/" className="app-mark">
            POMPEY BUILT
          </Link>
          {hideNav(pathname) ? null : <GlobalNav />}
        </div>
      </header>
      {children}
    </div>
  );
}
